// documentation:
//   in the file where you want the component:
//     step 1:
//       import component using correct path:
//         import MagnifiquePopup from './components/MagnifiquePopup.js';
// 	   step 2:
//  	 add useState:
// 		   const [appearPopup, setAppearPopup] = useState(false);
//     step 3:
//       add continue/cancel callbacks:
//         const continueCallback = () => {
//           insertFunction();
//         }
//         /*( optional -- if no cancelCallback is provided, the setTrigger is set to "false" and the popup closes - same for continueCallback now )*/
//         const cancelCallback = () => {
//           insertFunction();
//         }
//     step 4:
//       set up a button or something similar that will trigger the popup:
//         <button onClick={() => setAppearPopup(true)}></button>
//     step 5:
//       add component inside return() and adjust the attribute values as needed:
//         <MagnifiquePopup
//           id="signoutConfirmation"
//           trigger={appearPopup}
//           setTrigger={setAppearPopup}
//           header={<FormattedMessage id="message.signout.confirmation" />}
//           body={<FormattedMessage id="message.signout.explanation" />}
//         />
//     step 6:
//       optionally, add these attributes:
//         continueCallback={continueCallback} // action on Continue
//         cancelCallback={cancelCallback} // action on Cancel
//         cancelButton={<FormattedMessage id="button.no" />}
//         continueButton={<FormattedMessage id="button.yes" />}
//         continueAsSubmit={true}
//   CSS:
//     step 7:
//       don't forget the magnifiquepopup.css file


import React, { useContext, useEffect, useRef } from 'react';
import {FormattedMessage, IntlContext} from 'react-intl';
import './component-style-sheets/magnifiquepopup.css';


function MagnifiquePopup(props) {

	const { messages } = useContext(IntlContext);
	const cancelButtonRef = useRef(null);

	useEffect(() => {
		if (props.trigger && cancelButtonRef.current) {
			cancelButtonRef.current.focus();
		}
	}, [props.trigger]);

	return (props.trigger) ? (
		<div className="popup">
		  <section id={props.id} className="modal-dialog modal-content overlay-def" style={!!props.style ? props.style : {width:"75%", maxWidth:"50rem"}}>
		    {/* { props.children } */}
		    <header className="modal-header">
		      <h3 className="modal-title">{ props.header }</h3>
		    </header>

		    <div className="modal-body" style={{textWrap: "wrap"}}>
		      { props.body }
		    </div>

		    <div className="modal-footer" style={{borderTop:"0"}}>
		      <span
				ref={cancelButtonRef}
		        role="button" id="btnCloseOverlay" className="btn btn-sm btn-primary pull-left" title={messages["button.title.closeOverlay"]} tabIndex={0}
		        onClick={() => {
		        	props.setTrigger(false);
		        	if (props.cancelCallback) {
		        		props.cancelCallback();
		        	}
		        }}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						props.setTrigger(false);
						if (props.cancelCallback) {
							props.cancelCallback();
						}
					}
				}}
		      >
		        {props.cancelButton ? props.cancelButton : <FormattedMessage id="button.cancel"/>}
		      </span>
			  {!!props.continueAsSubmit || !!props.continueCallback || props.continueButton ?
			    !!props.continueAsSubmit ?
		        <button type="submit" id="btnContinue" className="btn btn-sm btn-success pull-right" title={messages["button.continue"]}>
		          {props.continueButton ? props.continueButton : <FormattedMessage id="button.continue"/>}
		        </button>
		      :
		        <span
		          role="button" id="btnContinue" className="btn btn-sm btn-success pull-right" title={messages["button.continue"]} tabIndex={0}
		          onClick={() => {
					props.setTrigger(false);
					if (props.continueCallback) {
						props.continueCallback();
					}
				}}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						props.setTrigger(false);
						if (props.continueCallback) {
							props.continueCallback();
						}
					}
				}}
		        >
		          {props.continueButton ? props.continueButton : <FormattedMessage id="button.continue"/>}
		        </span>
			  :
			    null
			  }
		    </div>
		  </section>
		</div>
	) : <></>;
}

export default MagnifiquePopup;